import React from "react";
import { Grid } from "@mui/material";
import Link from "next/link";
import styles from "./detail.module.scss";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";

export const ElearningDetailCourse = () => {
  return (
    <section className={styles.section_details}>
      <div className="container">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={7}>
            <div className={styles.course_description_wrapper}>
              <h3 className={styles.course_desc_title}>Program Highlights</h3>
              <ul>
                <li>
                  <div>
                    <h4 className={styles.para_title}>
                      UniSearch- IELTS - Student Offerings
                    </h4>
                    <p>
                      As a one-stop solution for students aiming to study
                      abroad, UniSearch offers complete, all-round support to
                      build the strongest applications possible - including
                      hitting your target IELTS scores. With us, you’re in the
                      hands of experts. Our courses are crafted and conducted by
                      best-in-class, certified IELTS trainers with a proven
                      track record of exceptional IELTS scores across India and
                      overseas.
                    </p>
                  </div>
                </li>
                <li>
                  <div>
                    <h4 className={styles.para_title}>
                      Classroom Training: 20 Hours
                    </h4>
                    <p>
                      To better understand the ins and outs of the IELTS,
                      including its format, sections, question types, score
                      charts, and relevant skill sets and strategies, students
                      complete 20 hours of real-time classroom training with our
                      experts. The classroom sessions will tackle all of the
                      four sections of the IELTS - Listening, Reading, Writing,
                      and Speaking - building students’ familiarity with the
                      question types and answer skills and strategies.
                    </p>
                    <p>
                      We understand that every student is different. This is why
                      it’s important to us to be able to give personalized
                      attention and feedback to every individual. To make sure
                      our coaches are able to give each student the fullest
                      attention, we cap off our classrooms at 15 students per
                      batch.
                    </p>
                  </div>
                </li>
                <li>
                  <div>
                    <h4 className={styles.para_title}>
                      Additional Support After Classroom Training
                    </h4>
                    <p>
                      <strong className={"color-orange"}>Mock Tests: </strong>{" "}
                      Students become familiar with the real exam and get hands
                      on their performance and progress by sitting for 4
                      full-length practice tests designed by Cambridge English
                      Language Assessment, IDP and British Council, the official
                      IELTS test administrators. UniSearch also offers
                      section-based tests for each of the 4 IELTS modules during
                      classroom training. Additionally, students have access to
                      two practice Speaking sessions with our coaches,
                      simulating the real exam with full evaluations of their
                      performance and guidance on how to improve
                    </p>
                    <p>
                      <strong className={"color-orange"}>
                        Doubt-Clearing Sessions:
                      </strong>{" "}
                      UniSearch offers unlimited one-to-one and group consulting
                      sessions for two months, to address each and every concern
                      and question students have while sitting for their IELTS
                    </p>
                    <p>
                      <strong className={"color-orange"}>
                        60-Day Course Validity:
                      </strong>{" "}
                      The standard 20-hour classroom training is designed to
                      cover all bases for our students to be test-ready for
                      their IELTS. However, since we understand that every
                      student learns differently and may seek additional
                      support, the course is fully valid for 60 days, during
                      which time students can retake classroom training and
                      attend doubt-clearing sessions (subject to available batch
                      schedules and respective faculty slots)
                    </p>
                    <p>
                      <strong className={"color-orange"}>
                        Study Materials:
                      </strong>{" "}
                      We refer and recommend official IELTS test preparation
                      materials for our students to provide the most accurate
                      and effective foundation for their test day success
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            {/* what_get_wrapper */}
            <div className={styles.what_get_wrapper}>
              <div className={styles.what_geat_head}>What You Get</div>
              <div className={styles.what_geat_body}>
                <ul>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/elearning/video-lesson.svg"
                      )}
                    />
                    <span>Virtual Classroom Training</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets("assets/images/elearning/mock-exam.svg")}
                    />
                    <span>Official Study Materials</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/elearning/study-materials.svg"
                      )}
                    />
                    <span>Full-Length and Sectional Tests</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/elearning/tutor-support.svg"
                      )}
                    />
                    <span>Doubt Clearing Sessions</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets("assets/images/elearning/guidence.svg")}
                    />
                    <span>Personalized Guidance</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/elearning/tutor-support.svg"
                      )}
                    />
                    <span>One-on-One speaking evaluations</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/elearning/tutor-support.svg"
                      )}
                    />
                    <span>One-on-One writing evaluations</span>
                  </li>

                  {/* <li className={styles.span_two}> */}
                </ul>
              </div>
            </div>

            {/* batch_schedule_wrapper */}
            <div className={styles.batch_schedule_wrapper}>
              {/* <div className={styles.schedule_title}>Batch Schedule :</div> */}

              {/* <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-1</span>
                        <span className={styles.last_child}>
                          22<sup>th</sup> FEB 2022
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          03:00 PM to 05:00 PM <br /> TUE to FRI
                        </span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-3</span>
                        <span className={styles.last_child}>
                          22<sup>nd</sup> APRIL 2022
                        </span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          05:30 P.M. to 7:30 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Tue - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-4</span>
                        <span className={styles.last_child}>9 MAY 2022</span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          10:00 P.M. to 12:00 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Mon - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-5</span>
                        <span className={styles.last_child}>17 MAY 2022</span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          05:30 P.M. to 7:30 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Tue - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-6</span>
                        <span className={styles.last_child}>23 MAY 2022</span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          10:00 A.M. to 12:00 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Tue - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-7</span>
                        <span className={styles.last_child}>02 JUNE 2022</span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          05:30 P.M. to 07:30 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Tue - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-8</span>
                        <span className={styles.last_child}>14 JUNE 2022</span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          10:00 A.M. to 12:00 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Tue - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-9</span>
                        <span className={styles.last_child}>21 JUNE 2022</span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          05:30 P.M. to 07:30 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Tue - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-10</span>
                        <span className={styles.last_child}>30 JUNE 2022</span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          10:00 A.M. to 12:00 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Tue - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-11</span>
                        <span className={styles.last_child}>12 JULY 2022</span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          05:30 P.M. to 07:30 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Tue - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.batch_schedule}>
                    <ul>
                      <li>
                        <span className={styles.first_child}>Batch-12</span>
                        <span className={styles.last_child}>19 JULY 2022</span>
                      </li>
                      <li>
                        <span className={styles.first_child}>Time</span>
                        <span className={styles.last_child}>
                          10:00 A.M. to 12:00 P.M. <br />
                        </span>
                      </li>
                      <li className>
                        <span className={styles.first_child}>Days</span>
                        <span className={styles.last_child}>Tue - Fri</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
              </Grid> */}
            </div>
            {/* course outline wrapper */}

            {/* <div className={styles.course_outline_wrapper}>
              <h3 className={styles.outline_title}>Course Outline</h3>
              <div className={styles.outline_sub_title}>
                4 Sections - 35 Topics
              </div>
              <FAQCard faq={faqData} />
            </div> */}
          </Grid>

          {/* right side */}
          <Grid item xs={12} sm={12} md={5}>
            <div className={styles.course_hithlights_wrapper}>
              <div className={styles.heighlight_head}>
                <img
                  src={getAssets(
                    "assets/images/elearning/Test-Prep-IELTS-Regular.png"
                  )}
                  alt="Course Details"
                />
              </div>

              <div className={styles.heighlight_body}>
                <div className={styles.course_price_highlight}>
                  {/* <div className={styles.course_price_prev}>₹ 10,000/-</div> */}
                  <div className={styles.course_price_now}>Rs 1499/-</div>
                </div>

                <Link legacyBehavior href="/elearning/ielts/enrol">
                  <a
                    className={`btn btn-secondary btn-bg btn-full ${styles.action_btn}`}
                  >
                    Enrol Now
                  </a>
                </Link>

                {/* <div className={styles.download_btn_wrapper}>
                  <a href="#" className={styles.download_btn} download>
                    <MdPictureAsPdf />
                    <span>Download Course Brochure</span>
                  </a>
                </div> */}

                <div className={styles.course_hithlights}>
                  <ul>
                    <li>
                      <span className={styles.first_child}>
                        2.5 weeks training
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        4 days live training and 3 days mock test practise from
                        official content
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Writing and speaking evaluation from experts
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        In class sectional mock test
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Evaluation through emails
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Doubt clearing sessions
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Course validity: 2 months
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        In class practise for vocabulary and grammar building
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Exercises to address speaking difficulties
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Tips for 9 bands IELTS preparation and time management
                      </span>
                    </li>
                    {/* <li>
                      <span className={styles.first_child}>
                        20 hours training
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Doubt clearing sessions
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        One-on-One speaking and writing evaluations
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Maximum 15 students per batch
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Practice on only official study material
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        Cambridge and IDP practise material
                      </span>
                    </li>
                    <li>
                      <span className={styles.first_child}>
                        2 months course validity
                      </span>
                    </li> */}
                    {/* <li>
                      <span className={styles.first_child}>Fees </span>
                      <span className={styles.last_child}>
                        ₹ 10,000/-{" "}
                        <span className={"color-orange"}>
                          Free for First 40 Enrolments
                        </span>
                      </span>
                    </li> */}
                    {/* <li>
                      <span className={styles.first_child}>
                        Free Enrollment to Counselling Services
                      </span>
                      <br />
                      <span className={styles.last_child}>
                        UK, CAN, AUS, NZ, IRE
                      </span>
                    </li> */}
                    <li>
                      <span
                        className={styles.first_child}
                        style={{ fontWeight: "normal" }}
                      >
                        *Only official IDP content used for practise and
                        teaching
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ElearningDetailCourse;
